import React, { Component } from "react"
import { validateToken } from '../../helpers/jwt-token-access/accessToken'
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'

//SweetAlert
import SweetAlert from "react-bootstrap-sweetalert";

import "react-datepicker/dist/react-datepicker.css";
import { Button, Card, CardBody, Col, Container, Row, Modal,
  ModalHeader,
  ModalBody,
  Nav, NavItem, NavLink, TabPane, TabContent, Label, Spinner} from "reactstrap"
import { AvForm } from "availity-reactstrap-validation";
import { Link } from "react-router-dom"
import { BaseUrl } from "../../helpers/Baseurl"
import classnames from "classnames";
import Select from "react-select";

//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';

const PackegeTypeGroup = [
	{ 
		label: "Packege Type",
		options: [
            { label: "Agent 1", value: "Agent 1" },
            { label: "Agent 2", value: "Agent 2" },
            { label: "Agent 3", value: "Agent 3" },
            { label: "Agent 4", value: "Agent 4" },
            { label: "Agent 5", value: "Agent 5" },

		]
	}
];

class Templates extends Component {
  constructor(props) {
    super(props)
    this.obj = JSON.parse(localStorage.getItem("authUser"))
        if (!this.obj){
            this.props.history.push('/logout')
        }else if (!validateToken(this.obj.access)){
            this.props.history.push('/logout')
        }
    this.state = {
      itinerary_id:"",
      alert_confirm : false,
      success_confirm : false,
      dynamic_title: "",
			dynamic_description: "",

      itineraries: [],
      selectedStartDate: null,
      selectedendDate: null,

      page:1,
      sizePerPage:20,
      totalSize:0,
      searchText:"",
      UsersGroup:[],
      activeTabJustify:"5",
      selectedAgent:{ label: "Agent 1", value: "Agent 1" },


      breadcrumbItems : [
        { title : "Planmans", link : "/dashboard" },
        { title : "Templates", link : "#" },
      ],
    }

    toastr.options = {
      positionClass: "toast-top-right",
      closeButton: "true",
      progressBar: "true",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      showDuration: 300,
      hideDuration: 1000,
      timeOut: 5000,
      extendedTimeOut: 1000
      }

    this.handleItineraryClicks = this.handleItineraryClicks.bind(this)
    this.handleCopyItinerary = this.handleCopyItinerary.bind(this)
    this.tog_copy = this.tog_copy.bind(this)
    this.toggleCustomJustified = this.toggleCustomJustified.bind(this)
  }
  componentDidCatch(error) {
    // Changing the state to true
    // if some error occurs
    console.log(error)
    this.props.history.push('/dashboard')
    toastr.error("Something Went Wrong", "")
  }

  tog_copy() {
    this.setState(prevState => ({
        modal_copy: !prevState.modal_copy
    }));
    this.removeBodyCss();
  }

  removeBodyCss() {
    document.body.classList.add("no_padding");
  }

  toggleCustomJustified(tab) {
		if (this.state.activeTabJustify !== tab) {
			this.setState({
				activeTabJustify: tab
			});
		}
	}



  async componentDidMount() {
    document.title = `Templates | Planmans`
 }
// Method for Load itinerary as per page, pagesize and filter 
 async loadData(url , sizePerPage, page , searchText){

    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
    };
    console.log(url, "----------------------url")
    await fetch(url,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
                this.setState(()=>({ itineraries: data.results, totalSize:data.count , page:page, sizePerPage, searchText }))
            },
            (error) => {
                console.log(error, 'error-------------') 
            }
        )  
  
 }

 handleSelectedAgent = selectedAgent =>{
  this.setState({ selectedAgent })
}

// create copy of selected itinerary api call 
 handleCopyItinerary = (e, values) => {
    const { itinerary_id } = this.state
    let data = {"itinerary_id":itinerary_id, "user_id" : this.obj.user.id }
    this.setState({loading:true})
  // const requestOptions = {
  //   method: 'POST',
  //   headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
  //   body: JSON.stringify(data)
  //   };
  //   fetch(`${BaseUrl}/api/itineraries/copy-added-itinerary/`,requestOptions)
  //       .then(res => 
  //           {if(res.status >= 400){
  //             toastr.error("Something Went Wrong", "")
  //             this.setState({
  //               itinerary_id:"",
  //               copy_success_confirm: false,
  //               copy_alert_confirm : false,
  //               }) 
  //           }
  //           else{
  //             let url = `${BaseUrl}/api/itineraries/itineraries/?size=${this.state.sizePerPage}&&page=${1}`
  //             this.loadData(url , this.state.sizePerPage, 1 , "")
  //               this.setState({
  //                 itinerary_id:"",
  //                 copy_success_confirm: true,
  //                 copy_alert_confirm : false,
  //                 dynamic_title: "Copied!",
  //                 dynamic_description: "Itinerary has been Copied."
  //                 })
  //           }    
  //       }
  //   )

}
// method for delete selected Itinerary and reload itinerary data as per current page and search input
 handleItineraryClicks = id => {  
    const requestOptions = {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${this.obj.access}`},
    
        };
          fetch(`${BaseUrl}/api/itineraries/itineraries/${id}/`,requestOptions)
                .then(res => 
                    {if(res.status >= 400){
                      console.log("error")
                    }
                    else{
                      let new_page = this.state.page
                      if(this.state.itineraries.length < 2){
                        new_page = new_page>1? new_page-1:1
                      }
                      let url = `${BaseUrl}/api/itineraries/itineraries/?size=${this.state.sizePerPage}&page=${new_page}&is_template=True`
                      url = this.state.searchText && this.state.searchText !== "" ? url+`&search=${this.state.searchText}`: url
                      this.loadData(url , this.state.sizePerPage, new_page , this.state.searchText)
                      this.setState({
                        itinerary_id:"",
                        success_confirm: true,
                        alert_confirm : false,
                        dynamic_title: "Deleted!",
                        dynamic_description: "Itinerary has been deleted.",
                        selectedStartDate:null,
                        selectedendDate:null,
                        })
                    }
                }
            )
  }

// Handle Table data as per filter and selected page  
  handleTableChange = (type, { page, sizePerPage, searchText, }) => {
    
    setTimeout(() => {
      let new_page = page
      let url = `${BaseUrl}/api/itineraries/itineraries/?size=${sizePerPage}&page=${new_page}&is_template=True`
      
      if (searchText && this.state.searchText !== ""){
          new_page = this.state.searchText !== searchText? 1 : new_page
          url = `${BaseUrl}/api/itineraries/itineraries/?size=${sizePerPage}&page=${new_page}&search=${searchText}&is_template=True`
    
      }
      this.loadData(url , sizePerPage, new_page , searchText)
    }, 1000);
  }

  render() {

    const { itineraries, sizePerPage, totalSize , page } = this.state
    const { SearchBar } = Search

    //pagination customization
    const pageOptions = {
      page: page,
      sizePerPage: sizePerPage,
      totalSize: totalSize, 
      custom: true,
    }

    const defaultSorted = [{
      dataField: 'id',
      order: 'asc'
    }];

    //Columns
    const itinerariesColumns = [
      {
        dataField: "id",
        text: "ID",
        sort: true,
        headerStyle: { width: '5%'  },
        formatter: (cellContent, row) => (
          `T-${row.id+100}`    
        )
      },
      {
        dataField: "title",
        text: "Name",
        sort: true,
        formatter: (cellContent, row) => (
            <Link to="#" onClick={() => this.props.history.push(`/template-detail/${row.id}`) } className="me-3 text-dark">{(row.title).substring(0,40)}</Link>
            ),
        title: (cell, row, rowIndex, colIndex) => `${cell}`
      },
      {
        dataField: "packege",
        text: "Package Type",
      },
      {
        dataField: "created_by",
        text: "Created By",
        formatter: (cellContent, row) => (
          row.created_by.first_name? row.created_by.first_name+" "+row.created_by.last_name :""
      )
      },
      {
        dataField: "created",
        text: "Created Date",
        sort: true,
        formatter: (cellContent, row) => (
            `${new Date(row.created).getDate()}-${new Date(row.created).getMonth()+1}-${new Date(row.created).getFullYear()}`       
        )
      },
      {
        dataField: "action",
        isDummyField: true,
        text: "Action",
        formatter: (cellContent, row) => (
          this.obj.user.is_superuser?
          <React.Fragment>
            <Link  to="#" onClick={()=> {this.tog_copy();this.setState({ itinerary_id:row.id })}} className="me-3 text-secondary"><i className="mdi mdi-content-copy font-size-18"></i></Link>
            <Link to="#" onClick={() => this.setState({ alert_confirm: true, itinerary_id:row.id })}  className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>
            </React.Fragment>
          :
          <React.Fragment>
            {/* <Link to="#" onClick={() => this.props.history.push(`/itinerary/${row.id}/${createSlugfromName(row.name)}`) } className="me-3 text-primary"><i className="fas fa-eye font-size-18"></i></Link> */}
            <Link  to="#" onClick={() => this.setState({ copy_alert_confirm: true, itinerary_id:row.id })} className="me-3 text-secondary"><i className="mdi mdi-content-copy font-size-18"></i></Link>
             </React.Fragment>
        ),
      },
    ]

    return (
      <React.Fragment>
        <div className="page-content">
          
          <Container fluid>
          <Breadcrumbs title="All Templates" breadcrumbItems={this.state.breadcrumbItems} />
            <Row>
              <Col xs="12">
                <Card>
                  <CardBody>
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      data={itineraries}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          data={itineraries}
                          columns={itinerariesColumns}
                          remote={{ filter: true, pagination: true, sort: true, cellEdit: true }}
                          bootstrap4
                          search
                        >
                          
                          {toolkitProps => (
                            <React.Fragment>
                              {/* Filter and search box  */}
                              <Row className="mb-2">
                                <Col sm="9">
                                  
                                    <div className="search-box me-2 mb-2 d-inline-block">
                                      <div className="position-relative">
                                        <SearchBar
                                          {...toolkitProps.searchProps}
                                        />
                                        <i className="bx bx-search-alt search-icon" />
                                      </div>
                                    </div>
                                  

                                </Col>
                              
                                <Col sm="3">
                                  <div className="text-sm-end">
                                    <Button
                                      type="button"
                                      color="success"
                                      className="btn-rounded mb-2 me-2"
                                      onClick={() => this.props.history.push("/new-template")}
                                    >
                                      <i className="mdi mdi-plus me-1" />{" "}
                                      Add New Template
                                    </Button>
                                  </div>
                                </Col>
                              </Row>
                              {/* End Filter and search box  */}
                              <div className="table-responsive">

                                <BootstrapTable
                                  remote
                                  {...toolkitProps.baseProps}
                                  {...paginationTableProps}
                                  responsive
                                  bordered={false}
                                  striped={true}
                                  defaultSorted={defaultSorted}                                
                                  headerWrapperClasses={"table-light"}
                                  columns = {itinerariesColumns}
                                  onTableChange={ this.handleTableChange }
                                  hover
                                  classes={
                                    "table align-middle table-nowrap"
                                  }
                                />
                                
                              </div>
                              <div className="pagination pagination-rounded justify-content-end mb-2">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                              
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
              <Col sm={6} md={4} xl={3} className="mt-4">
                        
                  <Modal
                  isOpen={this.state.modal_copy}
                  toggle={this.tog_copy}
                  centered={true}
                  >
                      <ModalHeader toggle={this.tog_copy}>
                      Copy Itinerary
                      </ModalHeader>
                      <ModalBody>
                          <Nav tabs className="nav-tabs-custom nav-justified">
                              <NavItem>
                                  <NavLink
                                      style={{ cursor: "pointer" }}
                                      className={classnames({
                                          active: this.state.activeTabJustify === "5"
                                      })}
                                      onClick={() => {
                                          this.toggleCustomJustified("5");
                                      }}
                                  >
                                      <span><i className="fas fa-map-signs"> In Itinerary</i></span>
                                  </NavLink>
                              </NavItem>
                              <NavItem>
                                  <NavLink
                                      style={{ cursor: "pointer" }}
                                      className={classnames({
                                          active: this.state.activeTabJustify === "6"
                                      })}
                                      onClick={() => {
                                          this.toggleCustomJustified("6");
                                      }}
                                  >
                                      <span><i className="fas fa-map-signs"> In Agent</i></span>
                                  </NavLink>
                              </NavItem>
                          </Nav>

                          <TabContent activeTab={this.state.activeTabJustify}>
                              
                              <TabPane tabId="5" className="p-3">
                                  <AvForm className="needs-validation" onValidSubmit={this.handleCopyItinerary} >
                                      
                                    {/* <Row>
                                      <Col md="6">
                                          <div className="mb-3">
                                          <Label className="form-label " htmlFor="name">Name</Label>
                                          <AvField
                                              name="name"
                                              placeholder="Itinerary Name"
                                              type="text"
                                              errorMessage="Enter Itinerary Name"
                                              className="form-control"
                                              validate={{ required: { value: true } }}
                                              id="name"
                                              
                                          />
                                          </div>
                                      </Col> 
                                      <Col md="6">
                                          <div className="mb-3">
                                          <Label className="form-label " htmlFor="customer_name">Customer Name</Label>
                                          <AvField
                                              name="customer_name"
                                              placeholder="Customer Name"
                                              type="text"
                                              errorMessage="Enter Customer Name"
                                              className="form-control"
                                              validate={{ required: { value: true } }}
                                              id="customer_name"
                                              
                                          />
                                          </div>
                                      </Col> 
                                    </Row>

                                    <Row>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <AvField
                                                    name="phone"
                                                    label="Contact Number"
                                                    placeholder="Contact Number (+91-9999999999)"
                                                    type="text"
                                                    errorMessage="Enter Only Digits"
                                                    validate={{
                                                        required: { value: true },
                                                        pattern: {
                                                            value: "^[0-9+-]+$",
                                                            errorMessage: "Only Digits"
                                                        },
                                                        
                                                    }}
                                                    />
                                            </div>
                                        </Col>
                                        <Col md="6">
                                            <div className="mb-3">
                                            <Label className="form-label " htmlFor="email">Email</Label>
                                            <AvField
                                                name="email"
                                                placeholder="Customer Email"
                                                type="email"
                                                errorMessage="Enter Customer Name"
                                                className="form-control"
                                                validate={{ required: { value: true } }}
                                                id="email"
                                                
                                            />
                                            </div>
                                        </Col> 
                                    </Row>
                                    <Row>
                                        <Col md="12">
                                            <div className="mb-3">
                                            <Label className="form-label " htmlFor="address">Address</Label>
                                            <AvField
                                                name="address"
                                                placeholder="Customer Address"
                                                type="text"
                                                errorMessage="Enter Address"
                                                className="form-control"
                                                id="address"
                                                
                                            />
                                            </div>
                                        </Col> 
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <div className="mb-3 form-floating">
                                                <AvField
                                                    name="zip_code"
                                                    label="Pin Code"
                                                    placeholder="Pin Code"
                                                    type="number"
                                                    validate={{
                                                        pattern: {
                                                        value: "^[0-9]+$",
                                                        errorMessage: "Only Digits"
                                                        }
                                                    }}
                                                    />
                                            </div>
                                        </Col>
                                    </Row> */}
                                      
                                    <Row>
                                          
                                      <Col md="6">
                                          {this.state.loading?
                                              <Spinner className="me-2 mt-3" color="primary" />
                                          :
                                              <div className="mt-3">
                                                  <Button type="submit" color="primary">
                                                      Copy to Itinerary
                                                  </Button>
                                              </div>
                                          }
                                      </Col>
                                    </Row>
                                  </AvForm>
                              </TabPane>
                                  
                              <TabPane tabId="6" className="p-3">
                                  <AvForm className="needs-validation" onValidSubmit={this.handleCopyItinerary} >
                                    <Row>
                                      <Col md="6">
                                        <div className="mb-3">
                                            <Label className="form-label">Select Agent</Label>
                                            <Select  
                                                value= {this.state.selectedAgent}
                                                onChange = {this.handleSelectedAgent}
                                                // isMulti={true}
                                                options={PackegeTypeGroup}
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                      </Col>
                                    </Row>                                      
                                    <Row> 
                                      <Col md="6">
                                          {this.state.loading?
                                              <Spinner className="me-2 mt-3" color="primary" />
                                          :
                                              <div className="mt-3">
                                                  <Button type="submit" color="primary">
                                                      Copy
                                                  </Button>
                                              </div>
                                          }
                                      </Col>
                                    </Row>
                                  </AvForm>
                              </TabPane>
                          </TabContent>
                      </ModalBody>
                  </Modal>
              </Col>
              {this.state.alert_confirm ? (
                <SweetAlert
                title="Are you sure?"
                warning
                showCancel
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="danger"
                onConfirm={() => this.handleItineraryClicks(this.state.itinerary_id)}
                onCancel={() =>
                    this.setState({
                        alert_confirm: false,
                        itinerary_id:"",
                    })
                }
                >
                You won't be able to revert this!
                </SweetAlert>
              ) : null}

            {this.state.success_confirm ? (
                <SweetAlert
                success
                title={this.state.dynamic_title}
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="danger"
                onConfirm={() => this.setState({ success_confirm: false, alert_confirm : false })}
                >
                    {this.state.dynamic_description}
                </SweetAlert>
                )
              : null
            }
            {/* {this.state.copy_alert_confirm ? (
              <SweetAlert
              title="Are you sure?"
              warning
              showCancel
              confirmBtnBsStyle="success"
              cancelBtnBsStyle="danger"
              onConfirm={() => this.handleCopyItinerary(this.state.itinerary_id)}
              onCancel={() =>
                  this.setState({
                      copy_alert_confirm: false,
                      itinerary_id:"",

                })
              }
              >
              You Really Want to replicate it !
              </SweetAlert>
            ) : null}

            {this.state.copy_success_confirm ? (
              <SweetAlert
              success
              title={this.state.dynamic_title}
              confirmBtnBsStyle="success"
              cancelBtnBsStyle="danger"
              onConfirm={() => this.setState({ copy_success_confirm: false, copy_alert_confirm : false })}
              >
                  {this.state.dynamic_description}
              </SweetAlert>
                )
                : null
              } */}
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

export default Templates